import React from 'react';

import "./ListTextInput.css";

export const ListTextInput = ({label, boldLabel, value, setValue, handleAddClick, disabled}) => {

    return (
        <div className="list-text-input-container">
            <p className={"list-text-input-header " + (boldLabel ? "bold" : null)}>{label}</p>
            <div className="list-text-input-input-container">
                <input value={value}
                       onChange={({target}) => {
                           setValue(target.value)
                       }}/>
                <button onClick={handleAddClick} disabled={disabled}>Add</button>
            </div>
        </div>
    );
}
